export type GeoSearchArgs = {
  query: {
    q?: string;
    postalcode?: string;
    country?: string;
    addressdetails?: string;
    namedetails?: string;
  };
  limit?: number;
  language?: string;
  format?: 'json' | 'jsonv2';
};

type GeoSearchResult = {
  place_id: number;
  licence: string;
  osm_type: string;
  osm_id: number;
  lat: string;
  lon: string;
  category: string;
  type: string;
  place_rank: number;
  importance: number;
  addresstype: string;
  name: string;
  display_name: string;
  boundingbox: string[];
  namedetails?: any;
  address?: { city: string; administrative: string; country: string; province: string; county: string; state: string };
}[];

export async function geoSearch({ query, limit, language, format = 'jsonv2' }: GeoSearchArgs) {
  try {
    const search = new URLSearchParams({ format, addressdetails: '1', namedetails: '1' });
    if (limit) {
      search.append('limit', limit.toString());
    }
    Object.entries(query).forEach(([key, value]) => {
      if (typeof value === 'string') {
        search.append(key, value);
      }
    });
    const headers = new Headers({
      'Content-Type': 'application/json',
    });
    if (language) {
      headers.set('Accept-Language', language);
    }
    const response = await fetch(`https://nominatim.openstreetmap.org/search?${search.toString()}`, {
      method: 'GET',
      headers: headers,
    });
    if (!response.ok) {
      throw { message: 'Network response was not ok', call: JSON.stringify(response) };
    }
    const json = await response.json();
    return json as GeoSearchResult;
  } catch (error) {
    console.error('Error:', error);
    return [] as GeoSearchResult;
  }
}

type GeoReverseArgs = {
  lat: string;
  lon: string;
  language: string;
  extra?: Record<string, unknown>;
};

export async function geoReverse({ lat, lon, language, extra }: GeoReverseArgs) {
  try {
    const search = new URLSearchParams({
      format: 'jsonv2',
      lat,
      lon,
      addressdetails: '1',
      namedetails: '1',
    });
    if (extra) {
      Object.entries(extra).forEach(([key, value]) => {
        if (typeof value === 'string') {
          search.append(key, value);
        }
      });
    }
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Accept-Language': language,
    });
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?${search.toString()}`, {
      method: 'GET',
      headers: headers,
    });
    if (!response.ok) {
      throw { message: 'Network response was not ok', call: JSON.stringify(response) };
    }
    const json = await response.json();
    return json as GeoSearchResult;
  } catch (error) {
    console.error('Error:', error);
    return [] as GeoSearchResult;
  }
}
